import { render, staticRenderFns } from "./EmailTemplateFormDialog.vue?vue&type=template&id=b48d9746"
import script from "./EmailTemplateFormDialog.vue?vue&type=script&lang=js"
export * from "./EmailTemplateFormDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplateFormDialog.vue?vue&type=style&index=0&id=b48d9746&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports